import CustomButton from "components/Button/Button";

interface DoneForgotPasswordProps {
  onClick: () => void;
}
const DoneForgotPassword = ({ onClick }: DoneForgotPasswordProps) => {
  return (
    <div className="signin-container">
      <div className="signin-title">Done!</div>
      <div className="signin-subtitle">
        If the information entered is associated with an PayPilot OTC account we
        have sent you an email with password reset instructions.
      </div>
      <CustomButton
        type="submit"
        btnName="Close"
        onClick={onClick}
        className="blue-btn close-btn"
        disabled={false}
      />
    </div>
  );
};
export default DoneForgotPassword;
